module.exports = __webpack_public_path__ + "static/media/SourceHanSansCN-Medium.4317a480.eot";